import {
  excludeAlert,
  excludeDisabledPolicy,
  excludeIrrelevantApp,
} from '../../../exclusions/actions/exclusions-actions';
import IssuesStore from '../../active-issues/stores/issues-store';
import {
  ExclusionCategory,
  ExclusionMode,
} from '../../../exclusions/types/exclusion-types';
import { snapshot, useSnapshot } from 'valtio';
import IssuesExclusionsStore from '../stores/issues-exclusions-store';
import PipelineIssuesStore from '../../pipeline-issues/stores/pipeline-issues-store';

export const onIrrelevantApp = () => {
  const issuesStore = snapshot(IssuesStore);
  if (issuesStore.selectedIssue) {
    excludeIrrelevantApp({
      appId: issuesStore.selectedIssue.app.id,
      appName: issuesStore.selectedIssue.app.name,
      issueName: issuesStore.selectedIssue.mainTitle,
      policyId: issuesStore.selectedIssue.policy.id,
      policyName: issuesStore.selectedIssue.policy.name,
      issueId: issuesStore.selectedIssue.issueId,
      appType: issuesStore.selectedIssue.app.type,
      policyCategory: issuesStore.selectedIssue.category.name,
      comment: issuesStore.selectedIssue.exclusionAppComment,
    });
  }
};

export const onDisablePolicy = () => {
  const issuesStore = snapshot(IssuesStore);
  if (issuesStore.selectedIssue) {
    excludeDisabledPolicy({
      appId: issuesStore.selectedIssue.app.id,
      appName: issuesStore.selectedIssue.app.name,
      issueName: issuesStore.selectedIssue.mainTitle,
      policyId: issuesStore.selectedIssue.policy.id,
      policyName: issuesStore.selectedIssue.policy.name,
      issueId: issuesStore.selectedIssue.issueId,
      appType: issuesStore.selectedIssue.app.type,
      policyCategory: issuesStore.selectedIssue.category.name,
      comment: issuesStore.selectedIssue.exclusionPolicyComment,
    });
  }
};

export const onExcludeIssue = () => {
  const { selectedAggs, excludeDefault: excludeFromCard } = snapshot(
    IssuesExclusionsStore,
  );
  const { selectedIssue } = snapshot(IssuesStore);
  const { selectedIssue: pipelineSelectedIssue } =
    snapshot(PipelineIssuesStore);

  const selectedAggsJson = selectedAggs.map(agg => JSON.stringify(agg));

  let id: string = '1';
  if (selectedIssue && excludeFromCard) {
    selectedIssue.exclusions.map(exclusion => {
      if (exclusion.isDefault) {
        id = exclusion.id;
      }
      return id;
    });
  } else if (pipelineSelectedIssue && excludeFromCard) {
    pipelineSelectedIssue.exclusions.map(exclusion => {
      if (exclusion.isDefault) {
        id = exclusion.id;
      }
      return id;
    });
  }
  if (selectedIssue) {
    const aggItemsJson = selectedIssue.aggregations.items.map(agg =>
      JSON.stringify(agg),
    );
    excludeAlert({
      oxIssueId: selectedIssue.issueId,
      issueId: selectedIssue.id,
      issueName: selectedIssue.mainTitle,
      appId: selectedIssue.app.id,
      appName: selectedIssue.app.name,
      policyName: selectedIssue.policy.name,
      rule: {
        exclusionCategory: selectedIssue.exclusionCategory as ExclusionCategory,
        aggs: selectedAggsJson.length > 0 ? selectedAggsJson : aggItemsJson,
        id: excludeFromCard ? id : IssuesExclusionsStore.excludeCategoryId,
      },
      policyId: selectedIssue.policy.id,
      appType: selectedIssue.app.type,
      policyCategory: selectedIssue.category.name,
      comment: selectedIssue.exclusionIssueComment,
      exclusionMode: ExclusionMode.fullScan,
      exclusionId: selectedIssue.exclusionId,
      expiredAt: selectedIssue.snoozeExpiredDate,
    });
  } else if (pipelineSelectedIssue) {
    const aggItemsJson = pipelineSelectedIssue.aggregations.items.map(agg =>
      JSON.stringify(agg),
    );
    excludeAlert({
      oxIssueId: pipelineSelectedIssue.issueId,
      issueId: pipelineSelectedIssue.id,
      issueName: pipelineSelectedIssue.mainTitle,
      appId: pipelineSelectedIssue.app.id,
      appName: pipelineSelectedIssue.app.name,
      policyName: pipelineSelectedIssue.policy.name,
      rule: {
        exclusionCategory:
          pipelineSelectedIssue.exclusionCategory as ExclusionCategory,
        aggs: selectedAggsJson.length > 0 ? selectedAggsJson : aggItemsJson,
        id: excludeFromCard ? id : IssuesExclusionsStore.excludeCategoryId,
      },
      policyId: pipelineSelectedIssue.policy.id,
      appType: pipelineSelectedIssue.app.type,
      policyCategory: pipelineSelectedIssue.category.name,
      comment: pipelineSelectedIssue.exclusionIssueComment,
      exclusionMode: ExclusionMode.pipelineScan,
      expiredAt: pipelineSelectedIssue.snoozeExpiredDate,
    });
  }
};

export const useIssuesExclusions = () => useSnapshot(IssuesExclusionsStore);
